// extracted by mini-css-extract-plugin
export default {"checkbox_input":"CheckboxInput_checkbox_input__Dzyf+","test_param_input":"CheckboxInput_test_param_input__oBYCa"};